var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("SRStoreList.BoxWrap.manage") } },
        [
          _c(
            "div",
            { staticClass: "action-container" },
            [
              _c(
                "el-form",
                {
                  attrs: { size: "small", inline: "", "label-position": "top" },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "row-bg", attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.form.storeName"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchQuery.rtlFullName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchQuery,
                                      "rtlFullName",
                                      $$v
                                    )
                                  },
                                  expression: "searchQuery.rtlFullName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SRStoreList.form.province"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    "value-key": "value",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  on: { change: _vm.provinceChangeEvent },
                                  model: {
                                    value: _vm.searchQuery.rtlRegion,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchQuery,
                                        "rtlRegion",
                                        $$v
                                      )
                                    },
                                    expression: "searchQuery.rtlRegion",
                                  },
                                },
                                _vm._l(
                                  _vm.regionOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item.label, value: item },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SRStoreList.form.city") },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    "value-key": "value",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchQuery.rtlCity,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchQuery, "rtlCity", $$v)
                                    },
                                    expression: "searchQuery.rtlCity",
                                  },
                                },
                                _vm._l(_vm.cityOptions, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: { label: item.label, value: item },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("DAStoreList.form.SRName"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchQuery.empName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchQuery, "empName", $$v)
                                  },
                                  expression: "searchQuery.empName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("DAStoreList.form.RTMType"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchQuery.rtlRtmCategory,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchQuery,
                                        "rtlRtmCategory",
                                        $$v
                                      )
                                    },
                                    expression: "searchQuery.rtlRtmCategory",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["STORE_RTM_TYPE"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "DAStoreList.form.retailStoreCategory"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    multiple: "",
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.searchQuery.retailerTypeList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchQuery,
                                        "retailerTypeList",
                                        $$v
                                      )
                                    },
                                    expression: "searchQuery.retailerTypeList",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["STORE_CATEGORY"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: {
                    click: function ($event) {
                      return _vm.searchPageOneTable(true)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("route.srstoreorderdetaillist") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["IMPORT"] },
                  expression: "{ pageName, list: ['IMPORT'] }",
                },
              ],
              attrs: { slot: "header-right" },
              slot: "header-right",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.openExportDialog },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.export")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.list,
                    stripe: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                    "show-summary": "",
                    "summary-method": _vm.getSummaries,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "storeCode",
                      label: _vm.$t("sfe.reportModule.storeOrders.storeCode"),
                      fixed: "",
                      width: "100px",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlRegion",
                      label: _vm.$t("sfe.reportModule.storeOrders.rtlRegion"),
                      fixed: "",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlCity",
                      label: _vm.$t("sfe.reportModule.storeOrders.rtlCity"),
                      fixed: "",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlFullName",
                      label: _vm.$t("sfe.reportModule.storeOrders.rtlFullName"),
                      fixed: "",
                      align: "center",
                      width: "180px",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "serviceProviderName",
                      label: _vm.$t(
                        "sfe.reportModule.storeOrders.serviceProviderName"
                      ),
                      fixed: "",
                      width: "140px",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "empName",
                      label: _vm.$t("sfe.reportModule.storeOrders.empName"),
                      fixed: "",
                      width: "120px",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rtlRtmCategory",
                      label: _vm.$t(
                        "sfe.reportModule.storeOrders.rtlRtmCategory"
                      ),
                      fixed: "",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "retailerType",
                      label: _vm.$t(
                        "sfe.reportModule.storeOrders.retailerType"
                      ),
                      fixed: "",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "january",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(_vm._s(_vm.paddingNum(scope.row.january))),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.january")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "february",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.paddingNum(scope.row.february))
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.february")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "march",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(_vm._s(_vm.paddingNum(scope.row.march))),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.march"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "april",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(_vm._s(_vm.paddingNum(scope.row.april))),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.april"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "may",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(_vm._s(_vm.paddingNum(scope.row.may))),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.may"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "june",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(_vm._s(_vm.paddingNum(scope.row.june))),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.june"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "july",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(_vm._s(_vm.paddingNum(scope.row.july))),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.july"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "august",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(_vm._s(_vm.paddingNum(scope.row.august))),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.august")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "september",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.paddingNum(scope.row.september))
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.september")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "october",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(_vm._s(_vm.paddingNum(scope.row.october))),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.october")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "november",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.paddingNum(scope.row.november))
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.november")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "december",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.paddingNum(scope.row.december))
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.december")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.tpp"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "janActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.janActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.january")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "febActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.febActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.february")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "marActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.marActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.march"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "aprActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.aprActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.april"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "mayActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.mayActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.may"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "junActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.junActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.june"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "julActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.julActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.july"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "augActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.augActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.august")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "sepActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.sepActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.september")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "octActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.octActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.october")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "novActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.novActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.november")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "decActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(scope.row.decActualSalesQty)
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.december")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("sfe.reportModule.storeOrders.st"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "janEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.janEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "sfe.reportModule.storeOrders.janEighteenActualSalesQty"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "febEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.febEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "sfe.reportModule.storeOrders.febEighteenActualSalesQty"
                              )
                            ) + "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "marEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.marEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "sfe.reportModule.storeOrders.marEighteenActualSalesQty"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "aprEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.aprEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "sfe.reportModule.storeOrders.aprEighteenActualSalesQty"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "mayEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.mayEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "sfe.reportModule.storeOrders.mayEighteenActualSalesQty"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "junEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.junEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "sfe.reportModule.storeOrders.junEighteenActualSalesQty"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "julEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.julEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "sfe.reportModule.storeOrders.julEighteenActualSalesQty"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "augEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.augEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "sfe.reportModule.storeOrders.augEighteenActualSalesQty"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "sepEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.sepEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "sfe.reportModule.storeOrders.sepEighteenActualSalesQty"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "octEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.octEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "sfe.reportModule.storeOrders.octEighteenActualSalesQty"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "novEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.novEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "sfe.reportModule.storeOrders.novEighteenActualSalesQty"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "decEighteenActualSalesQty",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.paddingNum(
                                    scope.row.decEighteenActualSalesQty
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.storeOrders.gy18Plus")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "sfe.reportModule.storeOrders.decEighteenActualSalesQty"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0,
                    expression: "total > 0",
                  },
                ],
                attrs: {
                  total: _vm.total,
                  page: _vm.currPage,
                  limit: _vm.limit,
                },
                on: {
                  "update:page": function ($event) {
                    _vm.currPage = $event
                  },
                  "update:limit": function ($event) {
                    _vm.limit = $event
                  },
                  pagination: function ($event) {
                    return _vm.fetchListData(false)
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("sfe.reportModule.exportSROrders"),
            visible: _vm.showExprotDialog,
            width: "30%",
            "before-close": _vm.closeExportDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "exportStoreForm",
              attrs: {
                model: _vm.exportForm,
                rules: _vm.exportFormRule,
                "label-width": "180px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sfe.reportModule.exportSROrders"),
                    prop: "exportYear",
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { "margin-bottom": "6px" },
                    attrs: {
                      clearable: false,
                      type: "year",
                      "value-format": "yyyy",
                    },
                    model: {
                      value: _vm.exportForm.exportYear,
                      callback: function ($$v) {
                        _vm.$set(_vm.exportForm, "exportYear", $$v)
                      },
                      expression: "exportForm.exportYear",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeExportDialog } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("common.cancel")) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.downloadLoading,
                      expression: "downloadLoading",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.submitExportDialog },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.confirm")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }